import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { ToastService } from './services/toast.service';
import { AnalyticsService } from './services/analytics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  brandName = environment.brandName;

  public appPages: any = [
    { title: 'Accueil', url: '/home', icon: 'home' },
    { title: 'Dash Commune', url: '/dash-commune', icon: 'grid' },
    { title: 'Dash App Citoyenne', url: '/dash-app', icon: 'grid' },
    {
      title: 'Accès des communes',
      url: '/gestion-acces',
      icon: 'people',
    },
  ];

  public securedPage = false;
  public applicationPage = false;
  public publicPage = false;
  public communePage = false;
  public conseilPage = false;
  public mobileSize = window.innerWidth < 768;
  isApp: any = true;
  elu: any;

  constructor(
    private router: Router,
    private platform: Platform,
    private apiService: ApiService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private cd: ChangeDetectorRef,
    private analyticsService: AnalyticsService
  ) {
    if (this.platform.is('cordova')) {
      platform.ready().then(() => {
        this.isApp = true;
        let token = localStorage.getItem('token');
        if (!token) {
          this.router.navigate(['/public/landing']);
        }
        this.analyticsService.initialize();
      });

      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          App.exitApp();
        }
      });
    } else {
      platform.ready().then(() => {
        // Commenter cette ligne pour forcer la version mobile
        // this.isApp = false;
        this.analyticsService.initialize();
      });
    }

    this.router.events.subscribe(async (evt) => {
      if (!(evt instanceof NavigationEnd)) return;
      // this.securedPage =
      //   evt.url.includes('/secured') ||
      //   evt.urlAfterRedirects.includes('/secured')
      //     ? true
      //     : false;

      this.applicationPage =
        evt.url.includes('/application') ||
          evt.urlAfterRedirects.includes('/application')
          ? true
          : false;
      this.publicPage =
        evt.url.includes('/public') || evt.urlAfterRedirects.includes('/public')
          ? true
          : false;

      if (this.publicPage) {
        this.securedPage = false;
      } else {
        this.securedPage = true;
      }

      this.communePage =
        evt.url.includes('/commune') ||
          evt.urlAfterRedirects.includes('/commune')
          ? true
          : false;

      this.conseilPage =
        evt.url.includes('/conseil') ||
          evt.urlAfterRedirects.includes('/conseil')
          ? true
          : false;

      if (this.conseilPage) {
        this.appPages = [];
        this.communePages = [];
        this.changeSidebarMenuConseil(evt.url);
      }

      if (this.communePage) {
        this.appPages = [];
        this.conseilPages = [];
        this.changeSidebarMenu(evt.url);
      }

      if (this.elu && this.elu.pwa_conseil_id) {
        this.appPages = [];
        if (this.communePage && !evt.url.includes('/fibre/carte')) {
          this.router.navigate(['/conseil']);
        }
        return;
      };

      if (this.elu && this.elu.departement_id) {
        this.appPages = [];
        
        // Get the current URL
        // const currentUrl = window.location.pathname;  // More reliable during reloads
        const currentUrl = evt.urlAfterRedirects || evt.url;
  
        // Only redirect if NOT on a public, commune or departement route
        if (!this.publicPage && !currentUrl.includes('/departement') && !currentUrl.includes('/commune')) {
          this.router.navigate(['/departement/' + this.elu.departement_id]);
        }
      }



      if (!this.communePage && !this.conseilPage && (this.elu && !this.elu.departement_id)) {
        this.communePages = [];
        this.conseilPages = [];
        this.appPages = [
          { title: 'Accueil', url: '/home', icon: 'home' },
          { title: 'Dash Commune', url: '/dash-commune', icon: 'grid' },
          { title: 'Dash App Citoyenne', url: '/dash-app', icon: 'grid' },
          {
            title: 'Accès des communes',
            url: '/gestion-acces',
            icon: 'people',
          },
        ];
      }

      if (!this.apiService.communes && this.securedPage) {
        this.apiService.getCommunes().subscribe();
      }

      if (!this.apiService.generalStats && this.securedPage) {
        this.apiService.getGeneralStats().subscribe();
      }

      // if (!this.apiService.allStatuses && this.securedPage) {
      //   this.apiService.getTicketStatuses().subscribe();
      // }

      // gestion des stats de visite
      // this.apiService.addStatsWebsite(evt.url);
    });
  }

  baseUrl: any;
  insee: any;

  public communePages: any;

  changeSidebarMenu(url: any) {
    this.baseUrl = url.split('/', 3).join('/');
    this.insee = this.baseUrl.split('/')[2];

    if (!this.elu.region_access) {
      this.checkUserAuthorization();
    }

    this.communePages = [
      { title: 'Accueil', url: this.baseUrl, icon: 'home' },
      {
        title: 'Fibre',
        url: this.baseUrl + '/fibre',
        icon: 'git-network-outline',
      },
      { title: 'Carte', url: this.baseUrl + '/fibre/carte', icon: 'map' },
      {
        title: 'Mes contacts',
        url: this.baseUrl + '/fibre/contacts',
        icon: 'people',
      },
      {
        title: 'Informations',
        url: this.baseUrl + '/fibre/informations',
        icon: 'help',
      },
      {
        title: 'Dommages réseaux',
        url: this.baseUrl + '/fibre/dommages',
        icon: 'alert',
      },
      {
        title: 'Actualités',
        url: this.baseUrl + '/fibre/actus',
        icon: 'newspaper',
      },
      {
        title: 'Opérateurs',
        url: this.baseUrl + '/fibre/operateurs',
        icon: 'wifi',
      },
      {
        title: 'Démarches',
        url: this.baseUrl + '/fibre/demarches',
        icon: 'file-tray-full',
      },
      {
        title: 'Documentations',
        url: this.baseUrl + '/fibre/documentations',
        icon: 'folder-open',
      },
      {
        title: 'Application',
        url: this.baseUrl + '/app',
        icon: 'business-outline',
      },
      {
        title: 'Actualités',
        url: this.baseUrl + '/app/actualites',
        icon: 'newspaper',
        disabled: true,
      },
      {
        title: 'Paramètres',
        url: this.baseUrl + '/app/parametres',
        icon: 'settings',
        disabled: true,
      },
    ];

    setTimeout(() => {
      if (!this.currentHome && !this.elu.pwa_conseil_id) {
        if (!this.insee || this.insee == 'undefined') return;
        this.apiService.getHome(this.insee).subscribe();
      }
    }, 3000);
  }

  public conseilPages: any;

  changeSidebarMenuConseil(url: any) {
    this.communePages = [];
    // this.conseilPages = [
    //   {
    //     title: 'Accueil',
    //     url: this.baseUrl + '/conseil',
    //     icon: 'home',
    //   }
    // ]

    this.conseilPages = [
    ]
  }

  async checkUserAuthorization() {
    if (this.elu.city_id) {
      const currentCommune = await this.apiService.returnCurrentCommuneByID(
        this.elu.city_id
      );
      if (currentCommune.insee !== this.insee) {
        this.router.navigate(['/commune/' + currentCommune.insee]);
      }
    } else if (this.elu.epci_id) {
      let epciInfos = this.apiService.epciInfos;
      if (epciInfos) {
        this.checkEPCIAuthorization(epciInfos);
      }
      if (!epciInfos && !this.router.url.startsWith('/epci')) {
        this.apiService.getEPCIInfos(this.elu.epci_id).subscribe();
      }
      this.apiService.epciInfosChanges.subscribe((infos) => {
        epciInfos = infos;
        this.checkEPCIAuthorization(epciInfos);
      });
    }
  }

  checkEPCIAuthorization(epciInfos: any) {
    const isAuthorized = epciInfos.epci_cities.find(
      (city: any) => city.insee == this.insee
    );

    if (!isAuthorized) {
      this.router.navigate(['/epci/' + this.elu.epci_id]);
    }
  }

  linksRS: any;
  currentHome: any;

  ngOnInit() {
    if (localStorage.getItem('elu') && !this.authService.elu) {
      this.elu = JSON.parse(localStorage.getItem('elu')!);
      this.authService.elu = this.elu;
    } else if (this.authService.elu) {
      this.elu = this.authService.elu;
    } else {
      this.authService.logout();
    }

    this.authService.eluChanges.subscribe((elu) => {
      this.elu = elu;
    });

    this.currentHome = this.apiService.currentHome;
    this.apiService.currentHomeChanges.subscribe((currentHome) => {
      this.currentHome = currentHome;
      this.linksRS = {
        facebook: currentHome.facebook,
        twitter: currentHome.twitter,
        linkedin: currentHome.linkedin,
        instagram: currentHome.instagram,
      };

      // if this.currentHome.rodp, add the rodp page after the documentations page
      if (this.currentHome.rodp && this.communePage) {
        this.communePages.splice(10, 0, {
          title: 'RODP',
          url: this.baseUrl + '/fibre/rodp',
          icon: 'logo-euro',
        });
      }
    });

    if (this.elu && this.elu.departement_id) {
      const currentPath = window.location.pathname;
      
      // Check if we're at the root path
      if (currentPath === '/' || currentPath === '') {
        this.router.navigate(['/departement/' + this.elu.departement_id]);
      }
    }
  }

  logout() {
    this.authService.logout();
  }

  isModalOpen = false;
  identifiant: any;
  password: any;

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }

  deleteAcc() {
    if (!this.identifiant || !this.password) {
      this.toastService.presentToast(
        'Veuillez remplir tous les champs',
        2000,
        'danger',
        'alert-circle-outline'
      );
      return;
    }

    this.apiService.deleteAccount(this.identifiant, this.password).subscribe(
      (res: any) => {
        this.toastService.presentToast(
          'Compte supprimé avec succès',
          2000,
          'success',
          'checkmark-circle-outline'
        );
      },
      (error) => { }
    );
  }
}
